// 倒计时
function getRandomNum(min, max) {
  return Math.floor(Math.random() * (max - min)) + min;
}

let endTimeG;

function cutDownTime() {
  let nowTime = new Date();
  let endTime = new Date(endTimeG);

  let leftTime = endTime.getTime() - nowTime.getTime();
  if (leftTime < 0) {
    setupNewCountdown();
    leftTime = 0;
  }
  let leftH = Math.floor((leftTime / (1000 * 60 * 60)) % 24),
    leftM = Math.floor((leftTime / (1000 * 60)) % 60),
    leftS = Math.floor((leftTime / 1000) % 60);
  leftH = leftH >= 10 ? leftH : "0" + leftH;
  leftM = leftM >= 10 ? leftM : "0" + leftM;
  leftS = leftS >= 10 ? leftS : "0" + leftS;

  return {
    hour: leftH,
    minute: leftM,
    second: leftS,
  };
}
function setupNewCountdown() {
  const randomHour = getRandomNum(1, 9);
  const currentTime = new Date();
  endTimeG = currentTime.setHours(currentTime.getHours() + randomHour);
}
let intervalId;

function getCutDownTime() {
  setupNewCountdown();
  if (intervalId) clearInterval(intervalId);
  intervalId = setInterval(function () {
    let cutDownTimeText = cutDownTime();
    $(".sp_top_cut_down .sp_left_view .sp_hour").html(cutDownTimeText.hour);
    $(".sp_top_cut_down .sp_left_view .sp_minute").html(cutDownTimeText.minute);
    $(".sp_top_cut_down .sp_left_view .sp_second").html(cutDownTimeText.second);
  }, 1000);
}

getCutDownTime();

jQuery("#nav0").slide({
  mainCell: ".nav-imgs",
  autoPlay: true,
  effect: "leftMarquee",
  interTime: 8,
  vis: 2,
  scroll: 2,
});

// new Swiper("#swiper-btn", {
//   autoplay: true,
//   autoplay: {
//     disableOnInteraction: false,
//     // delay: 5000,
//   },
//   loop: true,
//   spaceBetween: 30,
// });


function mainRender() {
  $(function () {
    $("#root").css("zoom", "normal");
    let scale = document.body.clientWidth / 1080;
    $("#root").css("zoom", scale);

    window.addEventListener(
      "resize",
      (function () {
        var timer;
        return function () {
          if (timer) clearTimeout(timer);
          timer = setTimeout(function () {
            $("#root").css("zoom", "normal");
            let scale = document.body.clientWidth / 1080;
            $("#root").css("zoom", scale);
          }, 100);
        };
      })()
    );
  });

  function lazyLoadImages() {
    // 懒加载
    const images = document.querySelectorAll(".lazy-load"); // 获取所有需要懒加载的图片
    const config = {
      rootMargin: "0px 0px 1300px 0px",
      threshold: 0,
    };

    const lazyLoadObserver = new IntersectionObserver(function (
      entries,
      observer
    ) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          // 当图片进入视口时
          const image = entry.target;
          const dataSrc = image.getAttribute("data-src");
          image.src = dataSrc; // 将data-src属性的值设置为图片的实际地址
          lazyLoadObserver.unobserve(image); // 停止观察该图片
        }
      });
    },
    config);

    images.forEach(function (image) {
      lazyLoadObserver.observe(image); // 开始观察每个图片
    });
  }

  function preloadImages(imageArray) {
    // 预加载
    // 检查数组数据结构
    if (Array.isArray(imageArray[0])) {
      // 处理二维数组
      imageArray.forEach((subArray) => {
        subArray.forEach((url) => {
          const img = new Image();
          img.src = url;
        });
      });
    } else {
      // 处理一维数组
      imageArray.forEach((url) => {
        const img = new Image();
        img.src = url;
      });
    }
  }

  document.addEventListener("DOMContentLoaded", function () {
    lazyLoadImages();

    preloadImages(spImgList);

    // 找到所有跳转套餐的锚点链接
    var links = document.querySelectorAll('a[href^="#shopping"]');
    links.forEach(function (link) {
      link.addEventListener("click", function (event) {
        event.preventDefault(); // 阻止默认的跳转行为
        // var targetElement = document.getElementById('shopping');
        // if (targetElement) {
        //     targetElement.scrollIntoView({ behavior: 'smooth' });
        // } // 方式一
        const targetElement = document.getElementById("shopping"); // 获取跳转目标节点
        const offsetTop = targetElement.offsetTop;
        window.scroll({
          top:
            offsetTop * $("div#root").css("zoom") -
            246 * $("div#root").css("zoom"),
          behavior: "smooth", // 使用 smooth 实现平滑滚动
        }); // 方式二
      });
    });
  });

  // IOS字体多了间距的处理 给节点添加 sp_system 类名
  // 判断当前用户是安卓端还是iOS端
  var userAgent = navigator.userAgent || navigator.vendor || window.opera;
  var isAndroid = /android/i.test(userAgent);
  var isIOS = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream;
  var isPC = !isAndroid && !isIOS && !/Iron/.test(userAgent); // 添加了对 "Iron" 关键词的判断

  if (isAndroid) {
    console.log("Android");
  } else if (isIOS) {
    console.log("iOS");
  } else if (isPC) {
    console.log("PC");
  } else {
    $(".sp_system").css("letter-spacing", "-4px");
  }

  let prods = window.product
  function getCur(){
    let color = $('#color div.active').attr('data-val')
    let size = $('#Size div.active').attr('data-val')
    return prods.filter(item=> item.option1 == color && item.option2 == size)[0]
  }
  function changePrice(){
    let num = $('#calcNumber').val()
    let price = (getCur().price * num / 100).toFixed(2)
    let compare = (getCur().compare_at_price * num / 100).toFixed(2)
    // if(num == 1){
    //   price = (getCur().price * num / 100).toFixed(2)
    // }else if(num == 2){
    //   price = (getCur().price * num / 100 * 0.95).toFixed(2)
    // }else if(num == 3){
    //   price = (getCur().price * num / 100 * 0.9).toFixed(2)
    // }else {
    //   price = (getCur().price * num / 100 * 0.85).toFixed(2)
    // }
    // price = (price + '').replace('.', ',')
    // compare = (compare + '').replace('.', ',')
    $('.product-part .price-group .price1 span').html(price)
    $('.product-part .price-group .price2 span').html(compare)
    let off_font = 100 - Math.ceil(getCur().price / getCur().compare_at_price * 100)
    $(".product-part .price-group .sp-row span").html(off_font);
  }

  $(".reduce").click(function () {
        let input = $(this).siblings("input")[0];
        let num = Number(input.value) - 1;
        if (num > 0) {
          input.value = num;
          changePrice()
        }
      });
      $(".add").click(function () {
        let input = $(this).siblings("input")[0];
        let num = Number(input.value) + 1;
        input.value = num;
        changePrice()
      });

  let spImgList = [
    [
      'https://cdn.shopify.com/s/files/1/0793/9516/0365/files/mascara1.png',
      'https://cdn.shopify.com/s/files/1/0793/9516/0365/files/mascara4.png',
      'https://cdn.shopify.com/s/files/1/0793/9516/0365/files/mascara3.png',
    ],
    [
      'https://cdn.shopify.com/s/files/1/0793/9516/0365/files/mascara2.png',
      'https://cdn.shopify.com/s/files/1/0793/9516/0365/files/mascara5.png',
      'https://cdn.shopify.com/s/files/1/0793/9516/0365/files/mascara6.png',
    ]
  ]
  var imgArr = [
      'https://cdn.shopify.com/s/files/1/0781/3405/1121/files/20240926-pro-0.png',
      'https://cdn.shopify.com/s/files/1/0781/3405/1121/files/20240926-pro-1.png?v=1729853926',
      'https://cdn.shopify.com/s/files/1/0781/3405/1121/files/20240926-pro-2.png?v=1729853926',
    'https://cdn.shopify.com/s/files/1/0781/3405/1121/files/20240926-pro-3.png',
      'https://cdn.shopify.com/s/files/1/0781/3405/1121/files/20240926-pro-4.png',
      'https://cdn.shopify.com/s/files/1/0781/3405/1121/files/20240926-pro-5.png',
    ]
  var imgArr2 = [
      'https://cdn.shopify.com/s/files/1/0781/3405/1121/files/spp_20250206161832_db46e96e1b594223a0a5095f78cd7e61_92859b3b-83a6-4f09-ba22-216a6a1222be.jpg?v=1756812833&width=1946',
      'https://cdn.shopify.com/s/files/1/0781/3405/1121/files/spp_20250206161833_67d234a945d140567a09f57fe1c37c4f_d0171d29-5685-4ad4-884e-fb1995bd34da.jpg?v=1756812833&width=1946',
      'https://cdn.shopify.com/s/files/1/0781/3405/1121/files/1_c38eba07-7e79-46ec-bef8-e6f3a286eacf.png?v=1757062321&width=1946',
      'https://cdn.shopify.com/s/files/1/0781/3405/1121/files/spp_20250206161830_f1044fc8a30d14f437114a757163b8b8_8bef8503-fa8e-4b12-af8a-90a2cd537c2b.jpg?v=1756812833&width=1946',
      'https://cdn.shopify.com/s/files/1/0781/3405/1121/files/spp_20250206161831_a36973ee83c8d01fdddb67bde74fc66a_c8938e4f-df26-458a-b1a7-5edb3ceffea9.jpg?v=1756812833&width=1946',
      'https://cdn.shopify.com/s/files/1/0781/3405/1121/files/1_c38eba07-7e79-46ec-bef8-e6f3a286eacf.png?v=1757062321&width=1946',
      
      'https://cdn.shopify.com/s/files/1/0781/3405/1121/files/spp_20250206161834_f9e334b04572996045916d3a7c2b3828_b7891dff-2298-42fc-a502-3f544b49d0c2.jpg?v=1756812833&width=1946',
      'https://cdn.shopify.com/s/files/1/0781/3405/1121/files/spp_20250206161834_f9e334b04572996045916d3a7c2b3828_c448d858-9ed2-4a32-ab9d-78380000a455.jpg?v=1756812833&width=1946',
      'https://cdn.shopify.com/s/files/1/0781/3405/1121/files/2_ff5f3c01-17b1-4c0d-b1dc-f059e9de9532.png?v=1757062321&width=1946',
      'https://cdn.shopify.com/s/files/1/0781/3405/1121/files/spp_20250206161830_f1044fc8a30d14f437114a757163b8b8_8bef8503-fa8e-4b12-af8a-90a2cd537c2b.jpg?v=1756812833&width=1946',
      'https://cdn.shopify.com/s/files/1/0781/3405/1121/files/spp_20250206161831_a36973ee83c8d01fdddb67bde74fc66a_c8938e4f-df26-458a-b1a7-5edb3ceffea9.jpg?v=1756812833&width=1946',
      'https://cdn.shopify.com/s/files/1/0781/3405/1121/files/2_ff5f3c01-17b1-4c0d-b1dc-f059e9de9532.png?v=1757062321&width=1946',
      
      'https://cdn.shopify.com/s/files/1/0781/3405/1121/files/spp_20250206161834_4937dec188c60ed6494e6a4891d51852_5e9f7f5d-d6b6-4769-9c76-71c606accd4b.jpg?v=1756812833&width=1946',
      'https://cdn.shopify.com/s/files/1/0781/3405/1121/files/spp_20250206161834_4937dec188c60ed6494e6a4891d51852_63ac702e-233d-40bd-a2d5-5b867a3624ec.jpg?v=1756812833&width=1946',
      'https://cdn.shopify.com/s/files/1/0781/3405/1121/files/3_c5b9fb2b-0a73-4c70-822c-2b9f3f4145df.png?v=1757062321&width=1946',
      'https://cdn.shopify.com/s/files/1/0781/3405/1121/files/spp_20250206161830_f1044fc8a30d14f437114a757163b8b8_8bef8503-fa8e-4b12-af8a-90a2cd537c2b.jpg?v=1756812833&width=1946',
      'https://cdn.shopify.com/s/files/1/0781/3405/1121/files/spp_20250206161831_a36973ee83c8d01fdddb67bde74fc66a_c8938e4f-df26-458a-b1a7-5edb3ceffea9.jpg?v=1756812833&width=1946',
      'https://cdn.shopify.com/s/files/1/0781/3405/1121/files/3_c5b9fb2b-0a73-4c70-822c-2b9f3f4145df.png?v=1757062321&width=1946',
    ]

  $(".option").click(function () {
    $(this).siblings().removeClass("active");
    $(this).addClass("active");
    changePrice()
    // let index = $(this).index()
    const colorIndex = $('#color .option.active').index()
    const sizeIndex = $('#Size .option.active').index()
    const _index = colorIndex + sizeIndex * 6
    console.log(_index)
    $('.product-part .swiper-box>img').attr('src', imgArr2[_index])
  });
  // style选项
    let typeOptions = $('#color .option')
    
    // 切换选项
    // typeOptions.click(function () {
    //   let index = $(this).index()
      
    //   $('.product-part .swiper-box>img').attr('src', imgArr[index])
    // })

  $(".cart-btn").click(function () {
          $(this).children("img").addClass("on");
          setTimeout(function () {
            $(".cart-btn").children("img").removeClass("on");
            $(".sp-header-top .sp-cart").removeClass("on");
          }, 500);
          $(".sp-header-top .sp-cart").addClass("on");
        });
        
        $(".product-part .cart-btn").click(function () {
          $('.c_toast').show()
          setTimeout(function () {
            $('.c_toast').hide()
          }, 1200);
          
           var data = {
            id: getCur().id,
            quantity: $('#calcNumber').val(),
          };
          
          $.ajax({
            type: "POST",
            url: "/cart/add.js",
            data: data,
            success: function () {
              $.getJSON(window.Shopify.routes.root + "cart.js", function (result) {
                $("#cardNum").html(result.item_count);
                handleAddToCart(result.item_count);
                $("#calcNumber").val(1);
              });
            },
            dataType: "json",
          });

          var img = $(".product-part .swiper-box img");
          var flyer = img[0].cloneNode(true);
          flyer.classList.add("sp_clone");

          $(".product-part").append(flyer);
          $(".sp_clone").css({
            width: img[0].width,
            height: img[0].height,
            position: "fixed",
            top: 0,
            left: img.offset().left,
            "z-index": "99",
          });

          let finish = $(".sp-cart");
          $(".sp_clone").animate(
            {
              top: finish[0].offsetTop + $(".time-part").height(),
              left: finish[0].offsetLeft + finish.width() / 2,
              width: 50, // 结束时的大小，根据需要调整
              height: 50, // 结束时的大小，根据需要调整
              opacity: 0.4,
              "z-index": "99",
            },
            500,
            "linear",
            function () {
              $(this).animate(
                {
                  width: 0,
                  height: 0,
                  opacity: 0,
                },
                0,
                function () {
                  $(".sp-header-top .sp-cart").addClass("sp-shake");
                  setTimeout(function () {
                    $(".sp-header-top .sp-cart").removeClass("sp-shake");
                  }, 400);
                  $(this).detach();
                }
              );
            }
          );
        });


  $('.buyNow').click(function(){
    let num = $('#calcNumber').val()
    window.location.href = '/cart/' + getCur().id + ':' + num
  })

}

mainRender();
